import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { avatarUrl, resolveImageUrl } from "../lib/api";
import { cn } from "../lib/utils";

const initials = (name) => (name ? name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "?");

export const UserAvatar = ({ userId, name, className, testId }) => {
  const { user } = useAuth();
  const isMe = user && userId === user.id;
  const src = isMe && user.profile_image ? resolveImageUrl(user.profile_image) : userId ? avatarUrl(userId) : null;
  const [failed, setFailed] = useState(false);

  useEffect(() => { setFailed(false); }, [src]);

  return (
    <div className={cn("rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 bg-[#6dbf4a]/15 text-[#6dbf4a] font-bold text-[10px]", className)}
      data-testid={testId}>
      {src && !failed
        ? <img src={src} alt={name || ""} className="w-full h-full object-cover" onError={() => setFailed(true)} />
        : <span>{initials(name)}</span>}
    </div>
  );
};
